import React from "react";
import PropTypes from "prop-types";

const Close = ({ ratio = 1, className, style }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" style={style}>
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);
Close.propTypes = {
  ratio: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object,
};
export default Close;



// WEBPACK FOOTER //
// ./components/common/CloseButton.jsx